
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppDateTimePicker } from '@/components';
import useItemSettingEdit from '@/modules/item/app/setting/model/edit';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';

export default defineComponent({
    name: ROUTE_NAME_ITEM.APP_SETTING.EDIT,
    components: { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppDateTimePicker },
    setup() {
        const { model, v$, timeUnits, update } = useItemSettingEdit();

        return { v$, model, timeUnits, update };
    }
});
